class AudioContextProvider {
  private audioContexts: Record<number, AudioContext> = {}

  getAudioContext(sampleRate: number): AudioContext {
    const existing = this.audioContexts[sampleRate]
    if (!existing || existing.state === 'closed') {
      this.audioContexts[sampleRate] = new AudioContext({ sampleRate })
    }
    return this.audioContexts[sampleRate]
  }

  async resume(sampleRate: number): Promise<void> {
    const ctx = this.getAudioContext(sampleRate)
    if (ctx.state !== 'running') {
      await ctx.resume()
    }
  }

  async suspend(sampleRate: number): Promise<void> {
    const ctx = this.audioContexts[sampleRate]
    if (ctx && ctx.state === 'running') {
      await ctx.suspend()
    }
  }

  async close(sampleRate: number): Promise<void> {
    const ctx = this.audioContexts[sampleRate]
    if (ctx && ctx.state !== 'closed') {
      await ctx.close()
    }
    delete this.audioContexts[sampleRate]
  }

  async closeAll(): Promise<void> {
    const rates = Object.keys(this.audioContexts)
    await Promise.all(rates.map(r => this.close(Number(r))))
  }
}

const instance = new AudioContextProvider()
Object.freeze(instance)
export default instance
